import { SOPException } from '@hakimo-ui/hakimo/types';
import { Button } from '@hakimo-ui/shared/ui-base';
import { PlusIcon } from '@heroicons/react/24/outline';
import SOPCard from './SOPCard';
import WorkflowFormExceptions from '../WorkflowFormExceptions';
import AIOperatorLabels from '../ai-operator-labels/AIOperatorLabels';
import CameraLabels from '../camera-labels/CameraLabels';
import TimeRangeLabels from '../time-range-labels/TimeRangeLabels';
import { renderEmptyState } from '../utils';

interface Props {
  exceptions: SOPException[];
  onChange: (val: SOPException[]) => void;
  isEditing: boolean;
  locationId?: string;
  compact?: boolean;
}

export function SOPExceptionsCard(props: Props) {
  const { exceptions, onChange, isEditing, locationId, compact } = props;

  const handleAddException = () => {
    const updatedExceptions = [...exceptions];
    updatedExceptions.push({
      text: '',
      isRelevantForAiOperator: true,
      cameras: [],
    });
    onChange(updatedExceptions);
  };

  const headerAction = isEditing ? (
    <Button
      variant="primary"
      onClick={handleAddException}
      className="flex items-center gap-2"
    >
      <PlusIcon className="h-4 w-4" />
      Add
    </Button>
  ) : null;

  return (
    <SOPCard title="Exceptions" headerAction={headerAction} compact={compact}>
      {isEditing ? (
        <div className="space-y-4">
          <WorkflowFormExceptions
            exceptions={exceptions}
            onChange={onChange}
            locationId={locationId}
          />
        </div>
      ) : exceptions && exceptions.length > 0 ? (
        <ol className="list-inside list-decimal space-y-4">
          {exceptions.map((exception, i) => (
            <li key={i} className="text-onlight-text-2 dark:text-ondark-text-2">
              <span className="break-words">{exception.text}</span>
              {(exception.timeRange ||
                exception.isRelevantForAiOperator !== undefined) && (
                <div className="my-2 flex flex-wrap gap-2 pl-4">
                  <AIOperatorLabels
                    isRelevantForAiOperator={exception.isRelevantForAiOperator}
                  />
                  {exception.timeRange && (
                    <TimeRangeLabels timeRange={exception.timeRange} />
                  )}
                </div>
              )}
              {exception.cameras && exception.cameras.length > 0 && (
                <div className="flex flex-wrap gap-2 pl-4">
                  {exception.cameras.map((camera, cameraIndex) => (
                    <CameraLabels key={cameraIndex} cameras={[camera]} />
                  ))}
                </div>
              )}
            </li>
          ))}
        </ol>
      ) : (
        renderEmptyState()
      )}
    </SOPCard>
  );
}

export default SOPExceptionsCard;
